<template>
    <div class="page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Profile</h4>
                </div>
            </div>
        </div>
        <div class="card card-body m-0">
            <div class="text-center mb-3">
                <img :src="avatar_image_path ? avatar_image_path : '/images/user-4.jpg'"
                     @click="addAvatar"
                     class="img-thumbnail avatar-image"
                     data-holder-rendered="true">
                <input @change="onAvatarChange"
                       accept="image/*"
                       ref="avatarFileInput"
                       type='file'
                       v-show="false"/>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Name:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('name') }"
                           class="form-control"
                           placeholder="Enter name"
                           title="Name"
                           type="text"
                           v-model="form.name">
                    <ul :class="{'filled' : form.errors.has('name')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('name') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Email:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('email') }"
                           class="form-control"
                           placeholder="Enter email"
                           title="Email"
                           type="text"
                           v-model="form.email">
                    <ul :class="{'filled' : form.errors.has('email')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('email') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Phone number:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('phone_number') }"
                           class="form-control"
                           placeholder="Enter phone number"
                           title="Phone number"
                           type="text"
                           v-model="form.phone_number"
                           @input="handlePhoneNumberInput">
                    <ul :class="{'filled' : form.errors.has('phone_number')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('phone_number') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">New password:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('password') }"
                           class="form-control"
                           placeholder="Enter new password"
                           title="New password"
                           type="password"
                           v-model="form.password">
                    <ul :class="{'filled' : form.errors.has('password')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('password') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Confirm new password:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('password_confirmation') }"
                           class="form-control"
                           placeholder="Confirm new password"
                           title="Password confirmation"
                           type="password"
                           v-model="form.password_confirmation">
                    <ul :class="{'filled' : form.errors.has('password_confirmation')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('password_confirmation') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center mt-3">
                <button :disabled="form.busy"
                        @click="submit()"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-content-save"/>
                    Save changes
                </button>
            </div>
        </div>
        <div v-if="hasRole(Roles.dealer_principle)">
            <company-profile />
            <mapbox />
            <company-settings />
        </div>
    </div>
</template>

<script>
    import CompanyProfile from "@/components/main/CompanyProfile";
    import CompanySettings from "@/components/main/CompanySettings";
    import Roles from "@/constants/roles";
    import Actions from "@/constants/store/actions";
    import Mapbox from "@/components/custom/Mapbox";
    import { validatePhoneNumber } from "@/utils/validation";

    export default {
        components: {
            CompanyProfile,
            CompanySettings,
            Mapbox,
        },
        data() {
            return {
                Roles,
                form: new Form({
                    name: null,
                    email: null,
                    phone_number: null,
                    password: null,
                    password_confirmation: null,
                    avatar: null,
                }, {
                    name: 'required|string|max:255',
                    email: 'required|email|max:255',
                    phone_number: 'string|max:255',
                    password: 'string|min:6|confirmed',
                    password_confirmation: 'string'
                }),
                avatar_image_path: null,
            }
        },
        mounted() {
            this.form = _.extend(this.form, _.pick(this.$store.state.user, ['name', 'email', 'phone_number']))
            this.avatar_image_path = this.$store.state.user.avatar;
        },
        methods: {
            addAvatar() {
                this.$refs.avatarFileInput.click();
            },
            onAvatarChange(e) {
                if (!e.target.files.length) {
                    return;
                }
                this.form.avatar = e.target.files[0];
                this.avatar_image_path = URL.createObjectURL(this.form.avatar);
            },
            submit() {
                this.form.validate()
                    .then(() => {
                        this.$confirm('Are you sure to save changes?', 'Confirm', {
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Cancel',
                            type: 'info'
                        }).then(() => {
                            App.postData('/web-api/account', this.form)
                                .then(() => {
                                    this.form.password = null;
                                    this.form.password_confirmation = null;
                                    this.$store.dispatch(Actions.refresh_auth_user);
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Successfully updated your profile.',
                                        type: 'success'
                                    });
                                })
                        });
                    });
            },
            handlePhoneNumberInput() {
                this.form.phone_number = validatePhoneNumber(this.form.phone_number);
            },
        }
    }
</script>

<style lang="scss" scoped>
.avatar-image {
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
}
</style>
